// extracted by mini-css-extract-plugin
export default {"wrap":"YellowText_wrap__1tzc+","text":"YellowText_text__QfJ0-","svg":"YellowText_svg__iEavB"};